import { Link } from "react-router-dom";
import { founder } from "@/data/siteContent";
import { footerTrustLinks, navigation } from "@/data/navigation";
import { uiText } from "@/data/uiText";
import { externalLinkProps } from "@/lib/externalLink";
import { tField } from "@/lib/i18nField";
import { resolveRoute } from "@/lib/resolveRoute";

export default function Footer({ lang }) {
  return (
    <footer className="tgwe-footer">
      <div className="tgwe-footer__grid">
        <section>
          <h2>{tField(uiText.aboutTgwe, lang)}</h2>
          <p>{tField(uiText.footerAboutText, lang)}</p>
        </section>
        <section>
          <h2>{tField(uiText.quickMenu, lang)}</h2>
          <nav className="tgwe-footer__links" aria-label="Footer navigation">
            {navigation.map((item) => {
              const label = tField(item.label, lang);
              if (item.type === "external-boundary") {
                return (
                  <a key={item.key} href={item.href} {...externalLinkProps(item.href)}>
                    {label}
                  </a>
                );
              }
              return (
                <Link key={item.key} to={resolveRoute(lang, item.key)}>
                  {label}
                </Link>
              );
            })}
          </nav>
          <div className="tgwe-footer__trust">
            <p>{tField(uiText.publicTrust, lang)}</p>
            <nav className="tgwe-footer__trust-links" aria-label={tField(uiText.publicTrust, lang)}>
              {footerTrustLinks.map((item) => (
                <Link key={item.key} to={resolveRoute(lang, item.key)}>
                  {tField(item.label, lang)}
                </Link>
              ))}
            </nav>
          </div>
        </section>
        <section>
          <h2>{tField(uiText.followUs, lang)}</h2>
          <div className="tgwe-socials">
            {founder.socials.map((link) => (
              <a key={link.id} href={link.href} title={`TGWE ${tField(link.label, lang)} Channel`} aria-label={tField(link.label, lang)} {...externalLinkProps(link.href)}>
                <img src={`/assets/images/${link.id === "odysee" ? "odysee.jpg" : `${link.id}.png`}`} alt="" loading="lazy" />
              </a>
            ))}
          </div>
        </section>
      </div>

      <section className="tgwe-footer__books" aria-labelledby="footer-books">
        <h2 id="footer-books">{tField(uiText.books, lang)}</h2>
        <div className="tgwe-footer__book-grid">
          {founder.books.map((book) => {
            const imageById = {
              "anarkhos-en": "kindle-cover-english.jpg",
              "anarkhos-es": "kindle-cover-espanol.jpg",
              "anarkhos-nl": "kindle-cover-nederlands.jpg"
            };
            return (
              <a key={book.id} href={book.href} className="tgwe-footer__book" {...externalLinkProps(book.href)}>
                <img src={`/assets/images/${imageById[book.id]}`} alt="" loading="lazy" />
                <span>{tField(book.label, lang)}</span>
              </a>
            );
          })}
        </div>
      </section>

      <div className="tgwe-footer__seal">
        <a href="https://onegreatworknetwork.com/glenn-tramm" aria-label="One Great Work Network" {...externalLinkProps("https://onegreatworknetwork.com/glenn-tramm")}>
          <img src="/assets/images/ogwn-flag.png" alt="One Great Work Network" loading="lazy" />
        </a>
        <p>
          {tField(uiText.footerSeal, lang).split("\n").map((line, index) => (
            <span key={line}>
              {index > 0 ? <br /> : null}
              {line}
            </span>
          ))}
        </p>
        <p>
          <em>"{tField(uiText.footerVerse, lang)}"</em>
        </p>
      </div>
    </footer>
  );
}
